import { render, staticRenderFns } from "./ConcurrentTicket.vue?vue&type=template&id=f0bdc702&scoped=true&"
import script from "./ConcurrentTicket.vue?vue&type=script&lang=js&"
export * from "./ConcurrentTicket.vue?vue&type=script&lang=js&"
import style0 from "./ConcurrentTicket.vue?vue&type=style&index=0&id=f0bdc702&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bdc702",
  null
  
)

export default component.exports